/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import * as React from "react";
import { Classes, DatePickerUtils } from "@blueprintjs/datetime";
import { IconSize } from "@blueprintjs/icons";
export function useMonthSelectRightOffset(monthSelectElement, containerElement, displayedMonthText) {
    var _a = React.useState(0), monthRightOffset = _a[0], setMonthRightOffset = _a[1];
    React.useLayoutEffect(function () {
        var _a, _b;
        if (containerElement.current == null) {
            return;
        }
        // measure width of text as rendered inside our container element.
        var monthTextWidth = DatePickerUtils.measureTextWidth(displayedMonthText, Classes.DATEPICKER_CAPTION_MEASURE, containerElement.current);
        var monthSelectWidth = (_b = (_a = monthSelectElement.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0;
        var rightOffset = Math.max(2, monthSelectWidth - monthTextWidth - IconSize.STANDARD - 2);
        setMonthRightOffset(rightOffset);
    }, [containerElement, displayedMonthText, monthSelectElement]);
    return monthRightOffset;
}
//# sourceMappingURL=useMonthSelectRightOffset.js.map